export default class AreaOfStudyDomainService {
    static fromJSON(json) {
        return Object.assign(Object.assign({}, json), { sisImportCreatedDate: json.sisImportCreatedDate && new Date(json.sisImportCreatedDate), sisImportModifiedDate: json.sisImportCreatedDate && new Date(json.sisImportModifiedDate) });
    }
}
